import './HelpDesktop.scss';
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';

import HelpNavDesktop from 'components/help/nav/HelpNavDesktop';
import HelpTopic from 'components/help/HelpTopic';

class HelpDesktop extends React.Component {
  static propTypes = {
    contextRef: PropTypes.object,
    helpState: PropTypes.object.isRequired,
    selectedNodeId: PropTypes.string,
  };

  static contextTypes = {
    getString: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      contentHeight: 0,
      navHeight: 0,
    };
    this.updateHeight = this.updateHeight.bind(this);
    this.handleExpansion = this.handleExpansion.bind(this);

    this.navContainer = React.createRef();
    this.contentContainer = React.createRef();
  }

  componentDidMount() {
    const updateHeightRef = this.updateHeight;

    updateHeightRef();

    // Respond to window resize events less frequently
    let resizeTimeout;
    this.throttledResize = function throttledResize() {
      if (!resizeTimeout) {
        resizeTimeout = setTimeout(() => {
          resizeTimeout = null;
          updateHeightRef();
        }, 1000);
      }
    };
    window.addEventListener('resize', this.throttledResize);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.state.contentHeight !== nextState.contentHeight
        || this.state.navHeight !== nextState.navHeight;
  }

  componentDidUpdate() {
    this.updateHeight();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.throttledResize);
  }

  handleExpansion() {
    // Nav & content heights need to be updated post-render (in componentDidUpdate)
    // instead of just post-update in order to get the correct current height.
    this.forceUpdate();
  }

  updateHeight() {
    const contentHeight = this.contentContainer.current.clientHeight;
    const navNode = ReactDOM.findDOMNode(this.navContainer.current);
    // Semantic UI's Sticky component wraps this component in a heightless div when it's stuck.
    // We need to get an inner node, which actually has a height.
    const navHeight = navNode.getElementsByClassName('aa-help-nav-desktop')[0].clientHeight;

    this.setState({
      contentHeight,
      navHeight,
    });
  }

  render() {
    const { contentHeight, navHeight } = this.state;
    const { helpState, contextRef, selectedNodeId } = this.props;

    return (
      <div>
        <h1 id="aa-help-desktop-root-topic-title">
          { helpState.currentNode.rootAncestorTitle }
        </h1>
        <div className="aa-help-desktop-grid">
          <Grid>
            <Grid.Column width={12}>
              <HelpTopic
                helpNode={helpState.currentNode}
                contentHeight={contentHeight}
                ref={this.contentContainer}
              />
            </Grid.Column>
            <Grid.Column width={4}>
              <HelpNavDesktop
                nodeHierarchy={helpState.nodeHierarchy}
                contextRef={contextRef}
                contentHeight={contentHeight}
                navHeight={navHeight}
                onHeightUpdate={this.handleExpansion}
                selectedNodeId={selectedNodeId}
                ref={this.navContainer}
              />
            </Grid.Column>
          </Grid>
        </div>
      </div>
    );
  }
}

export default HelpDesktop;
